var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangleFilled = function SvgAlertTriangleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.812 1.669a2 2 0 0 0-1.625 0c-.4.177-.659.49-.84.745-.177.25-.367.58-.576.94l-8.267 14.28c-.21.363-.401.692-.53.972-.132.284-.274.666-.229 1.102a2 2 0 0 0 .813 1.41c.355.258.757.326 1.068.354.307.028.688.028 1.107.028h16.534c.419 0 .8 0 1.106-.028.312-.029.714-.096 1.068-.354a2 2 0 0 0 .814-1.41c.045-.436-.098-.818-.23-1.102-.128-.28-.32-.61-.53-.972L14.23 3.354c-.21-.36-.4-.69-.577-.94-.18-.255-.44-.568-.84-.745M13 9a1 1 0 0 0-2 0v4a1 1 0 1 0 2 0zm-1 7a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2z",
    clipRule: "evenodd"
  })));
};
export default SvgAlertTriangleFilled;